import { normalizeTemplateList } from '../utils/normalizeTemplate';

export function extractTemplateList(data) {
  if (Array.isArray(data)) return data;
  return data?.list ?? data?.results ?? [];
}

export function extractTemplateListCount(data, listLength = 0) {
  return data?.count ?? data?.total_count ?? listLength;
}

export function parseTemplateListResponse(res) {
  const rawList = extractTemplateList(res?.data);
  const list = Array.isArray(rawList) ? rawList : [];
  return {
    templates: normalizeTemplateList(list),
    count: extractTemplateListCount(res?.data, list.length),
  };
}
